//互评
export const SK_COMMENT_LIST = 'sk_comment_list'
//互评详情
export const SK_COMMENT_DETAILS = 'sk_comment_details'
//互评添加
export const SK_COMMENT_ADD = 'sk_comment_add'
//互评编辑
export const SK_COMMENT_EDIT = 'sk_comment_edit'